import { AgResourceLanguage } from '../types';
import { cart as EnUsCart } from '../en-us/cart';

export const cart: AgResourceLanguage['cart'] = {
  ...EnUsCart,
  subscriptionTitle: 'Abonnemang',
  oneTimeTitle: 'Engångsköp',
  giftCartTitle: 'Gåvobeställning',
  oneTimeDescription: 'Dessa artiklar kommer att levereras med din första abonnemangsbeställning:',
  oneTimeCarouselTitle: 'Du kanske också gillar',
  clearCartText: 'Rensa Produkter',
  oneTimeCarouselAddButton: 'Lägg till',
  title: 'Din Varukorg',
  checkoutButtonLabel: 'Till Kassan',
  emptyState: {
    oneTimeProductsTitle: 'Medlemmarnas Favoriter',
    addOneTimeProductButton: 'Lägg till i Varukorgen',
    label: 'Lägg till artiklar i din varukorg'
  },
  emptyStateLabel: 'Lägg till artiklar i din varukorg',
  frequencyLabel: 'Skickas var 30:e dag:',
  deliveryInfo:
    'När du slutför köpet kommer du att debiteras och denna beställning skickas inom 24 timmar M-F efter betalning. Vänligen tillåt upp till 48 timmar under helger och helgdagar.',
  deleteItemModal: {
    title: 'Radera Artiklar Från Varukorgen',
    description: 'Är du säker på att du vill radera artiklar från varukorgen?'
  },
  clearCartModal: {
    title: 'Ta Bort Alla Artiklar Från Varukorgen',
    description: 'Är du säker på att du vill ta bort alla artiklar från varukorgen?'
  },
  free: 'Gratis',
  scoopPrompt: 'Behöver du en skopa till din påse? Lägg till den nedan gratis.'
};
